import { render, staticRenderFns } from "./stamp.vue?vue&type=template&id=579311e6&"
import script from "./stamp.vue?vue&type=script&lang=js&"
export * from "./stamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports